import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Jelly Match's own Firebase project (same jelliq-game project the Flutter
// game uses for progress/leaderboard). Named "jelly" so this app instance
// never collides with the other two games' instances in the same page.
const firebaseConfig = {
  apiKey: 'AIzaSyCR14gM003-G21qx42fEHVMsZjle0K9AhI',
  authDomain: 'jelliq-game.firebaseapp.com',
  projectId: 'jelliq-game',
  storageBucket: 'jelliq-game.firebasestorage.app',
  messagingSenderId: '681288997876',
  appId: '1:681288997876:web:d08b002d1dda99f9c177a1',
};

export const app = initializeApp(firebaseConfig, 'jelly');
export const db = getFirestore(app);
export const auth = getAuth(app);
